import { ActionTypes } from "./actions.js";
import { getInitialState } from "./state.js";
const initialState = getInitialState();
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.setSortOrder:
            const { sort } = action.payload;
            return { ...state, sort };
        case ActionTypes.setPage:
            const { page } = action.payload;
            return { ...state, page };
        case ActionTypes.setFiltersDraft:
            const { filtersDraft } = action.payload;
            return { ...state, filtersDraft };
        case ActionTypes.setFiltersDraftOutbound:
            const { filtersDraftOutbound } = action.payload;
            return { ...state, filtersDraftOutbound };
        case ActionTypes.setFiltersDraftInbound:
            const { filtersDraftInbound } = action.payload;
            return { ...state, filtersDraftInbound };
        case ActionTypes.applyFilters:
            return { ...state, filters: state.filtersDraft };
        case ActionTypes.applyFiltersOutbound:
            return { ...state, filters: state.filtersDraftOutbound };
        case ActionTypes.applyFiltersInbound:
            return { ...state, filters: state.filtersDraftInbound };
        case ActionTypes.resetFiltersDraftOutbound:
            return { ...state, filtersDraft: getInitialState().filters };
        case ActionTypes.resetFiltersDraftOutbound:
            return { ...state, filtersDraftOutbound: getInitialState().filters };
        case ActionTypes.resetFiltersDraftInbound:
            return { ...state, filtersDraftInbound: getInitialState().filters };
        case ActionTypes.resetFilters:
            const { filters } = getInitialState();
            return { ...state, filters: filters, filtersDraft: filters };
        case ActionTypes.resetFiltersOutbound: {
            const { filters } = getInitialState();
            return { ...state, filters: filters, filtersDraftOutbound: filters };
        }
        case ActionTypes.resetFiltersInbound: {
            const { filters } = getInitialState();
            return { ...state, filters: filters, filtersDraftInbound: filters };
        }
        case ActionTypes.resetFiltersButKeep:
            const filtersInitState = getInitialState().filters;
            return {
                ...state,
                filters: { ...filtersInitState, ...action.payload.filter },
                filtersDraft: { ...filtersInitState, ...action.payload.filter },
                filtersDraftOutbound: { ...filtersInitState, ...action.payload.filter },
                filtersDraftInbound: { ...filtersInitState, ...action.payload.filter }
            };
        case ActionTypes.setValueFromSB:
            const { searchboxVal } = action.payload;
            return { ...state, ...searchboxVal };
        case ActionTypes.resetFilter:
            const { filter } = action.payload;
            const initialState = {};
            initialState[filter] = getInitialState().filters[filter];
            return {
                ...state,
                filters: { ...state.filters, ...initialState },
                filtersDraft: { ...state.filtersDraft, ...initialState }
            };
        case ActionTypes.resetFilterOutbound: {
            const { filter } = action.payload;
            const initialState = {};
            initialState[filter] = getInitialState().filters[filter];
            return {
                ...state,
                filters: { ...state.filters, ...initialState },
                filtersDraftOutbound: { ...state.filtersDraftOutbound, ...initialState }
            };
        }
        case ActionTypes.resetFilterInbound: {
            const { filter } = action.payload;
            const initialState = {};
            initialState[filter] = getInitialState().filters[filter];
            return {
                ...state,
                filters: { ...state.filters, ...initialState },
                filtersDraftInbound: { ...state.filtersDraftInbound, ...initialState }
            };
        }
        default:
            return state;
    }
};
export { reducer, getInitialState };
